import { render, staticRenderFns } from "./GroupBarChart.vue?vue&type=template&id=c2b2889c"
import script from "./GroupBarChart.vue?vue&type=script&lang=js"
export * from "./GroupBarChart.vue?vue&type=script&lang=js"
import style0 from "./GroupBarChart.vue?vue&type=style&index=0&id=c2b2889c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports